import { z } from 'zod';

const decimalString = z
  .union([z.string(), z.number()])
  .transform((value) => String(value))
  .refine((value) => /^-?\d+(\.\d+)?$/.test(value), 'invalidDecimal');

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'invalidDate');

export const CashBalanceResponseSchema = z.object({
  id: z.string(),
  account_id: z.string(),
  currency: z.string(),
  value_date: isoDate,
  balance: decimalString,
  day_movement: decimalString,
  movement_count: z.number().int(),
  last_movement_at: z.string().nullable(),
});

export type CashBalanceResponse = z.infer<typeof CashBalanceResponseSchema>;

export const CashBalanceListSchema = z.array(CashBalanceResponseSchema);

export const CashBalanceFiltersSchema = z.object({
  currency: z.string().trim().optional(),
  accountId: z.string().trim().optional(),
  asOfDate: isoDate.optional(),
});

export type CashBalanceFilters = z.infer<typeof CashBalanceFiltersSchema>;

export const CashBalancesPayloadSchema = z.object({
  filters: CashBalanceFiltersSchema.optional(),
});

export type CashBalancesPayload = z.infer<typeof CashBalancesPayloadSchema>;
